<script>
export default {
  name: 'UniImage',
};
</script>

<script setup>
import { ref } from 'vue';

const loading = ref(true);
const error = ref(false);

const onLoad = () => {
  loading.value = false;
};

const onError = () => {
  loading.value = false;
  error.value = true;
};
</script>

<template>
  <img
    src=""
    alt="Loading image..."
    class="tw-w-full"
    :class="{
      'skeleton tw-h-16 tw-w-36 tw-rounded-sm tw-bg-gray-100': loading,
      'error-label tw-h-16 tw-w-36 tw-rounded-sm tw-bg-red-200 tw-text-[0]':
        error,
    }"
    @load="onLoad"
    @error="onError"
  />
</template>

<style scoped lang="scss">
.error-label:before {
  color: darkred !important;
  content: 'Error loading image' !important;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
  font-style: normal;
}
</style>
